module.exports = __webpack_public_path__ + "static/media/commentbn.60c2f4a0.png";